export const styles = {
  customDrawerPaper: {
    '&> .MuiDrawer-paper': {
      [`@media (min-width: ${992}px)`]: {
        width: '50%',
      },
    },
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#f1f1f1ab !important',
      cursor: 'pointer',
    },
  },
}
export default styles
